export default __webpack_public_path__ + "_/images/big-dark-logo-cfbf4b9caa63eee83a875664fd425f9e3f53eef9d497b8340308950ba712b525.png";